<template>
  <validation-observer ref="simpleRules">
    <projects-item-form />
    <save-button
      :save-action="submitForm"
      :is-disabled="submitStatus"
    />
  </validation-observer>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import ProjectsItemForm from '@/views/Projects/ItemForm.vue'

export default {
  name: 'Add',
  components: {
    ProjectsItemForm,
    ValidationObserver,
    SaveButton,
  },
  data() {
    return {
      submitStatus: false,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['projects/dataItem']
    },
    saveData() {
      return this.$store.getters['projects/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.watcherError) {
        this.showToast({
          variant: 'warning', title: this.$t('common.toast.warning'), icon: 'AlertTriangleIcon', text: this.$t('projects.form.watcherError'),
        })
      }
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: this.$t('common.toast.success'), icon: 'CheckIcon', text: val.message,
        })
        this.$router.push('/app/projects')
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: this.$t('common.toast.error'), icon: 'XIcon', text: val.message,
        })
        this.submitStatus = false
      }
    },
  },
  created() {
    this.$store.commit('projects/RESET_DATA_ITEM')
  },
  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('projects/saveData', this.itemData)
        } else {
          this.showToast({
            title: this.$t('common.toast.warning'),
            icon: 'XIcon',
            text: this.$t('common.requiredFields'),
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
